import { ParseJsonField } from 'workflow-definition/openapi';

export const resolvePathByFieldId = (
  fields: ParseJsonField[],
  targetId: number,
  parentPath = ''
): string | null => {
  for (const field of fields) {
    const path = parentPath
      ? `${parentPath}.${field.name ?? ''}`
      : (field.name ?? '');
    if (field.id === targetId) return path;
    if (field.childs?.length) {
      const found = resolvePathByFieldId(field.childs, targetId, path);
      if (found) return found;
    }
  }
  return null;
};

export const flatParsedJson = (array: ParseJsonField[]) => {
  let result: ParseJsonField[] = [];
  array.forEach(function (a) {
    result.push(a);
    if (Array.isArray(a.childs)) {
      result = result.concat(flatParsedJson(a.childs));
    }
  });
  return result;
};

export const flatParsedJsonWithPath = (
  array: ParseJsonField[],
  parentPath = ''
): (ParseJsonField & { path: string })[] => {
  let result: (ParseJsonField & { path: string })[] = [];
  array.forEach(a => {
    const path = parentPath ? `${parentPath}.${a.name ?? ''}` : (a.name ?? '');
    result.push({ ...a, path });
    if (Array.isArray(a.childs)) {
      result = result.concat(flatParsedJsonWithPath(a.childs, path));
    }
  });
  return result;
};
